import React from 'react';

import FiveOhEight from '../components/FiveOhEight';
import HelpButtonWidget from '../widgets/HelpButtonWidget';

class DatasetsMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // HelpButtonWidget
            showHelpText: false,
        };
    }

    _renderHelpText() {
        if (!this.state.showHelpText) {
            return null;
        }
        return (
            <div className="alert alert-info">
                <p>
                    This page includes tabs that provide tabulated parameters of protocols (Tab
                    name: Protocols), details of test substances (Tab name: Test Substances), the
                    mapping of laboratory specific recording to phenotype ontology terms (Tab name:
                    Phenotype Ontology).
                </p>
                <br />

                <p>White boxes in each table indicate search boxes.</p>
                <br />

                <p>Tables are available to download in each tab.</p>
            </div>
        );
    }

    render() {
        return (
            <div className="d-flex flex-wrap mx-5 my-3">
                <div className="col-12">
                    <h1 className="label-horizontal">
                        <img
                            src="/static_seazit/img/seazit/logo-5.png"
                            alt="Logo"
                            className="img-fluid"
                            style={{ marginRight: '10px', height: '50px' }}
                        />
                        Data
                        <HelpButtonWidget
                            stateHolder={this}
                            headLevel={'h1'}
                            title={'Click to toggle help-text'}
                        />
                    </h1>
                    {this._renderHelpText()}
                </div>
                <div className="col-12">
                    <FiveOhEight />
                </div>
            </div>
        );
    }
}

export default DatasetsMain;



// WEBPACK FOOTER //
// ./seazit/assets/seazit/containers/DatasetsMain.js